import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const AppointmentLayout = () => (
  <>
    <header style={{ sticky: 'top', zIndex: 1000 }}>
      {/* Swasthya Reconstructed Public Text-Logo Mark */}
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
        <div style={{ fontWeight: '800', fontSize: '20px', color: 'var(--sage-deep)', letterSpacing: '0.5px' }}>
          SWASTHYA
        </div>
        <div style={{ fontSize: '10px', fontStyle: 'italic', color: 'var(--ink-soft)' }}>
          A journey towards mental well-being
        </div>
      </div>

      <nav style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/">Home</Link>
        <a href="#facilities">Facilities</a>
        <a href="#services">Services</a>
        <a href="#contact">Contact Us</a>
        <Link to="/login" className="btn-blue" style={{ marginLeft: '25px' }}>Login</Link>
      </nav>
    </header>
    <main><Outlet /></main>
  </>
);

export default AppointmentLayout;